import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';

type Props = {
  content: CmsApiPage;
};

export function getContentOnlySearchResults({ content }: Props) {
  const { heroSearch } = content;
  // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
  return heroSearch && heroSearch.onlyResults;
}
